<template>
  <div class="tableWithPerPageSelection">
    <div class="tableWithPerPageSelection">
      <div class="entete border-entete">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3">{{ $t('listeTypeContact.title')}}</h1>
                <app-breadcrumb :breadcrumb="breadcrumb" />
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="is-pulled-right buttons boutonAction">
              <a
                class="button is-addOrEdit"
                @click="checkPermissions(permission.maj)
                  ? addEdit(null) : showPopUp()"
                :class="{'button-access-no-permission' :
                  !checkPermissions(permission.maj)}">
                {{ $t('listeTypeContact.actions.add')}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form @submit.prevent class="column is-12">
            <b-input
              v-model="filterInput"
              :placeholder="$t('listeTypeContact.actions.search')"
              type="search"
              icon="magnify">
            </b-input>
          </form>
        </div>
      </div>
    </div>
    <v-client-table
      :data="listeFilter"
      :columns="columns"
      :options="options"
      ref="tableTypeContact">
      <template slot='afterTable'>
        <table-items-in-view @input="$refs.tableTypeContact.setLimit($event)"/>
      </template>
      <div slot="typeContactType" slot-scope="props">
        <span> {{getTypeContactType(props.row.typeContactType)}} </span>
      </div>
      <div slot="edit" slot-scope="props">
        <div
          @click="checkPermissions(permission.supprimer) ?
            addEdit(props.row) : showPopUp()"
          class="is-cursor-pointer">
          <b-icon
            icon="pencil-box-outline"
            type="is-success"
            :class="{'text-access-no-permission':
              !checkPermissions(permission.maj)}">
          </b-icon>
        </div>
      </div>
      <div slot="archiver">
        <div
          @click="checkPermissions(permission.supprimer)
            ? inProgress() : showPopUp()"
          class="is-cursor-pointer">
          <b-icon
            type="is-default"
            icon="archive"
            :class="{'text-access-no-permission':
              !checkPermissions(permission.supprimer)}">
          </b-icon>
        </div>
      </div>
      <div slot="delete">
        <div
          @click="checkPermissions(permission.supprimer)
            ? inProgress() : showPopUp()"
          class="is-cursor-pointer">
          <b-icon
            type="is-danger"
            icon="delete-forever"
            :class="{'text-access-no-permission':
              !checkPermissions(permission.supprimer)}"
          ></b-icon>
        </div>
      </div>
    </v-client-table>
    <b-modal
      v-model="popUpAddEdit"
      class="modal"
      has-modal-card>
      <PopUpAdd
        :typeContact="selected"
        @reload="loadData()"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import messageErreur from '@/services/general/messageErreur';
import inProgress from '@/services/general/inProgress';
import breadcrumb from '@/components/general/breadcrumb';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import PopUpAdd from '@/components/parametrage/typeContact/p_addEdit';
import TableItemsInView from '@/components/general/TableItemsInView';
import { SET_FILTER } from '@/store/modules/parametrage/typeContact-mutation-type';
import genererTypeContact from '@/services/parametrage/typeContact/genererTypeContact';
import { TYPE_CONTACT } from '@/configuration/general/permissionsParametrageConf';
import { LISTE_TYPE_CONTACT_TYPE } from '@/configuration/bodac/typeContact/typeContactConf';

const Permissions = createNamespacedHelpers('permissions');
const TypeContact = createNamespacedHelpers('typeContact');

export default {
  data() {
    return {
      permission: TYPE_CONTACT,
      popUpAddEdit: false,
      selected: {},
    };
  },
  components: {
    PopUpAdd,
    appBreadcrumb: breadcrumb,
    TableItemsInView,
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$t('listeTypeContact.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeTypeContact.breadcrumb.parametrage'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('listeTypeContact.breadcrumb.liste'), route: { name: '' }, isActive: true },
      ];
    },
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...TypeContact.mapGetters({
      typesContact: 'items',
      filter: 'filter',
    }),
    filterInput: {
      get() {
        return this.filter;
      },
      set(val) {
        this.setFilter(val);
      },
    },
    listeFilter() {
      return this.typesContact.filter(item => {
        return item.libelle.toLowerCase().includes(this.filter.toLocaleLowerCase()
          || this.filter);
      });
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          libelle: this.$t('listeTypeContact.tab.libelle'),
          typeContactType: this.$t('listeTypeContact.tab.typeContactType'),
          edit: '',
          archiver: '',
          delete: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        columnsClasses: {
          edit: 'colonneSelected',
          archiver: 'colonneSelected',
          delete: 'colonneSelected',
        },
        sortable: ['libelle', 'typeContactType'],
      };
    },
    columns() {
      return ['libelle', 'typeContactType', 'edit', 'archiver', 'delete'];
    },
  },
  methods: {
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...TypeContact.mapActions({
      actionsload: 'load',
    }),
    ...TypeContact.mapMutations({
      setFilter: SET_FILTER,
    }),
    addEdit(data) {
      if (!data) this.selected = genererTypeContact();
      else this.selected = cloneDeep(data);
      this.popUpAddEdit = true;
    },
    getTypeContactType(value) {
      const find = LISTE_TYPE_CONTACT_TYPE.find(el => el.value === value);
      if (find) return this.$t(find.libelle);
      return '';
    },
    async loadData() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.actionsload();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  async mounted() {
    this.setInformationPage(this.$t('pageParametrage.typeContact.liste'));
    await this.loadData();
  },
};

</script>
